import React from 'react';
import '../../styles/dashboard.css';

const TopProducts = () => {
  const products = []; // This would come from API

  return (
    <div className="top-products">
      <h3>Top Products</h3>
      {products.length === 0 ? (
        <p className="no-data">No data available</p>
      ) : (
        <div className="products-list">
          {products.map(product => (
            <div key={product.id} className="product-item">
              <span>{product.name}</span>
              <span>{product.quantity} sold</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TopProducts;